module.exports = __webpack_public_path__ + "img/progress-bar-dark-01.3d496091.png";